import { AxiosRequestConfig } from "axios";

import { ApiResponse, _delete, get } from "@api/httpClient";

export interface ApplicantsExamsFilesResponse {
  filename: string;
  sizeInBytes: number;
}

export interface DeleteApplicantsExamsFilesPayload {
  filenames: string[];
}

interface ApplicantsExamsFilesParams<T = any> {
  applicantExamId: number;
  resultId: number;
  options: AxiosRequestConfig<T>;
}

export async function getApplicantsExamsFiles({
  applicantExamId,
  resultId,
  options,
}: ApplicantsExamsFilesParams) {
  const { data } = await get<ApplicantsExamsFilesResponse[]>(
    `/api/applicants/exams/${applicantExamId}/results/${resultId}/localfiles/metadata`,
    options,
  );

  return data;
}

export async function deleteApplicantsExamsFiles({
  applicantExamId,
  resultId,
  options,
}: ApplicantsExamsFilesParams<DeleteApplicantsExamsFilesPayload>) {
  const { data } = await _delete<ApiResponse<string>>(
    `/api/applicants/exams/${applicantExamId}/results/${resultId}/localfiles`,
    options,
  );

  return data;
}
